// Copyright 2016 Sorama B.V.

export class Point3 {
    public readonly x: number;

    public readonly y: number;

    public readonly z: number;

    constructor(x: number, y: number, z: number) {
        this.x = x;
        this.y = y;
        this.z = z;
    }

    public static Subtract(a: Point3, b: Point3): Point3 {
        return new Point3(a.x - b.x, a.y - b.y, a.z - b.z);
    }

    public static Distance(a: Point3, b: Point3): number {
        const diff = Point3.Subtract(b, a);
        return Math.sqrt(diff.x * diff.x + diff.y * diff.y + diff.z * diff.z);
    }
}
